import React from 'react';

import { LucidTheme } from '@lucid/theme';

import Box from '../../box/box';
import Icon from '../../icon/icon';

interface QuoteCarouselArrowType {
  /** Direction the arrow is facing */
  direction?: string;
  /** Event that will occur onClick */
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const QuoteCarouselArrow = ({ direction = 'right', onClick, ...rest }: QuoteCarouselArrowType) => (
  <Box
    {...rest}
    css={(theme: LucidTheme) => ({
      maxWidth: theme.space.s120,
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    })}
    onClick={onClick}
  >
    <Icon
      css={{
        transform: direction === 'right' ? '' : 'rotate(180deg)',
        height: '24px',
      }}
      type="CarotRight"
    />
  </Box>
);

export default QuoteCarouselArrow;
